export default function () {
  //付加した style をリセット
  $('.js-mr').removeAttr('style');
  $('.p-cof__text, .p-cof__select, .p-cof__textarea').removeAttr('style');

  if( $('.u-hidden-gtTAB').css('display') == 'none' ) {
    //右の余白をグリッドに合わせる
    $('.js-mr').each(function() {
      $(this).css('margin-right', $('.l-page').width() * .1699 + 'px');
    });

    //フォームの幅をグリッドに合わせる
    //テーブルセル
    $('.p-cof__table th').css('width',  (Math.floor($('.l-page').width() * .167)　-　1) + 'px');

    //インプット要素
    $('.p-cof__text, .p-cof__select, .p-cof__textarea').each(function() {
      console.log("1");
      //カラム以外
      if($(this).closest('.p-cof__item').length < 1) {
        if($(this).closest('.mwform-tel-field').length < 1) {
          if($(this).closest('.p-cof__wm').length < 1) {
            $(this).css('width', Math.floor($('.l-page').width() * .4981) + 'px');
          }
        }
      }
      //電話番号
      if($(this).closest('.mwform-tel-field').length > 0) {
        $(this).css('width', Math.floor($('.l-page').width() * .102) + 'px');
      }
      //2カラム
      if($(this).closest('.p-cof__item').length > 0) {
        $(this).closest('.p-cof__wm').css('width', Math.floor($('.l-page').width() * .334) + 'px');
      }
      //郵便番号
      if($(this).closest('.p-cof__zip').length > 0) {
        $(this).closest('.p-cof__item').css('width', Math.floor($('.l-page').width() * .0776) + 'px');
      }
    })
  }
}
